import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "../../primitives/hover-card";

interface NotResearchedProps {
  children: React.ReactNode;
  /**
   * True when enrichment has run at least once for this customer. Distinguishes
   * "not yet researched" (show CTA tooltip) from "researched but no public
   * information available" (show neutral tooltip).
   */
  isEnriched?: boolean;
}

/**
 * Dashed-underline fallback for a field where enrichment has no value.
 * Hover tooltip distinguishes the two "why is this blank" paths so the
 * UI teaches the user what action — if any — would unblock it.
 */
export function NotResearched({ children, isEnriched }: NotResearchedProps) {
  return (
    <HoverCard openDelay={150}>
      <HoverCardTrigger asChild>
        <span className="border-b border-dashed border-muted-foreground/50 cursor-help">
          {children}
        </span>
      </HoverCardTrigger>
      <HoverCardContent className="w-64 text-xs" side="top">
        {isEnriched
          ? "Enrichment found no public information for this field."
          : "Hasn't been enriched yet. Run enrichment to surface this."}
      </HoverCardContent>
    </HoverCard>
  );
}
